<script lang="ts">
    import Header from "./components/Header.svelte";
    import Hero from "./components/Hero.svelte";
    import Services from "./components/Services.svelte";
    import ContactUs from "./components/ContactUs.svelte";
    import Footer from "./components/Footer.svelte";
</script>

<svelte:head>
    <script id="plausible" defer data-domain="nolines.online" src="https://plausible.io/js/plausible.compat.js"/>
    <script defer data-domain="nolines.online" src="https://plausible.io/js/plausible.hash.js"/>
</svelte:head>

<div>
    <Header/>
    <Hero/>
    <Services/>
    <ContactUs/>
    <Footer/>
</div>

<style lang="postcss" global>
    @tailwind base;
    @tailwind components;
    @tailwind utilities;
</style>